import T from '@wojtekmaj/react-t';

import { Small, Wrapper } from './marketing_disclaimers.styles';

import PrivacyPolicyLink from '../privacy_policy_link';

export default function MarketingDisclaimers() {
  return (
    <Wrapper>
      <Small>
        <T link={<PrivacyPolicyLink />}>
          {
            'The administrator of your personal data is Lajkonik. House of Bakery Sp. z o.o. with its registered office in Kraków (31-509), ul. Lubomirskiego 20. Your personal data will be processed for the purpose of registering and managing your user account in the Lajkonik loyalty program, including sending you marketing communications related to your participation in the loyalty program (also using profiling), as well as for the administrator’s statistical and analytical purposes. If you give the appropriate consent, your data will also be processed for the purpose of sending you marketing content in the form of electronic mail to the provided e-mail address. More information about the processing of personal data, including your rights, can be found in our {link}.'
          }
        </T>
      </Small>
    </Wrapper>
  );
}
